(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warm-offer"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.wg-offer__pause').forEach(button=>{
button.addEventListener('click',()=>{
const section=button.closest('.wg-offer');
const paused=section.dataset.paused!=='true';
section.dataset.paused=String(paused);
button.setAttribute('aria-pressed',String(paused));
button.setAttribute('aria-label',paused?button.dataset.playLabel:button.dataset.pauseLabel);
button.querySelector('span').textContent=paused?'▶':'Ⅱ';
});
});

  } catch(e) { console.error(e); }
})();
})();
